export const getBanner = (state, res) => {
  state.datatables = res
}

export const listBanner = (state, res) => {
  state.lists = res
}

export const setDetail = (state, res) => {
  state.detail = res
}
